<script setup lang="ts">
import type { BoardCard } from "@/model/card";

import StickyTypeBreakdown from "./StickyTypeBreakdown.vue";

defineProps<{ title: string; description: string; cards: BoardCard[] }>();
</script>

<template>
  <div v-if="cards.length > 0" class="blocked-group">
    <div class="text">
      <h3 class="title">{{ title }}</h3>
      <p class="description">{{ description }}</p>
    </div>
    <StickyTypeBreakdown :cards="cards" class="types" />
  </div>
</template>

<style lang="scss" scoped>
@use "@/styles/mixins/typography";
@use "@/styles/variables/colors";

.blocked-group {
  display: flex;
  flex-direction: column;
  gap: inherit;

  .text {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .title {
      @include typography.medium("bold");

      color: colors.$text;
    }

    .description {
      @include typography.small("semi-bold");
    }
  }

  .types {
    color: colors.$text;
  }
}
</style>
